import React from 'react';
import HeroSection from '../components/home/heroSection';
import InfoSection from '../components/home/infoSection';

const Home = () => (
  <div>
    <HeroSection />
    <InfoSection />
  </div>

);

export default Home;
